import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import { NgClass } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
    selector: 'app-explore-your-brain',
    templateUrl: './explore-your-brain.component.html',
    styleUrls: ['./explore-your-brain.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, RouterLink]
})
export class ExploreYourBrainComponent {
  @Input() shouldHaveGrayBackground = true;
  @Input() callToActionText = 'Ready to explore your brain?';
  @Input() callToActionButtonText = 'Get started';
  @Input() callToActionButtonLink = '../dashboard';
}
